import { resolvePath, formatString, formatUrl, isFunction, setScrollPosition, isRelativeURL } from '@config/utils';
import theme from './theme'
import { CheckPermission } from './acls';

export default {
    props: {
        // moduleCode passed by route
        // moduleCode: {
        //     type: String,
        //     default: null
        // },
    },
    data() {
        return {
            fromRoute: null,
            pageTitle: '',
            addTitle: 'Adicionar',
            updateTitle: 'Atualizar',
            configTitle: 'Configurar',
            submitTitle: 'Salvar',
            cancelTitle: 'Cancelar',
            deleteTitle: 'Remover',
            searchPlaceholder: 'Pesquisar...',
            noResults: 'Sem Resultados',
            btnBackTitle: 'Voltar',
            btnSaveTitle: 'Salvar',
            btnPrintTitle: 'Imprimir',
            notFoundMsg: 'Sem resultados',
        }
    },
    mixins: [
        theme,
        CheckPermission
    ],
    mounted() {
        if(this.$route.meta.title){
            let title = this.$route.meta.title;
            let i8nTitle = this.$t(title);
            this.pageTitle = i8nTitle == title ? title : i8nTitle;
        }
        this.hideTooltip();
        this.activeTooltip();
    },
    beforeRouteEnter (to, from, next) {
        next( (vm) => {
            vm.fromRoute = from;
        });

    },
    // beforeRouteLeave(to, from) {
    //     console.log('beforeRouteLeave')
    //     this.$store.dispatch('breadcrumbChanged', undefined);
    //     return true;
    // },
    computed: {
        initialPagePlatform(){
            return this.$root.$env.FIRST_COMPONENT.name;
        },
        maxUploadSize(){
            return this.$root.$env.UPLOAD_MAX;
        },
        isDisabled() {
            if(this.fields && this.fields.$form){
            // console.log(':', this.fields.$form);
            // console.log(':', this.errors.any());
            // console.log(':', Object.keys(this.fields.$form).some(key => this.fields.$form[key].dirty) );
            // console.log(':', Object.keys(this.fields.$form).every(key => this.fields.$form[key].validated) );
            // console.log(':', Object.keys(this.fields.$form).every(key => this.fields.$form[key].valid) );
                return this.errors.any() || (
                        !(
                            Object.keys(this.fields.$form).some(key => this.fields.$form[key].dirty
                                || this.fields.$form[key].changed)
                            &&
                            (Object.keys(this.fields.$form).every(key => this.fields.$form[key].validated)
                                || Object.keys(this.fields.$form).every(key => this.fields.$form[key].valid
                                    || this.fields.$form[key].valid==null))
                        )
                    );
            }
            return true;
        },
    },
     methods: {
        setScrollPosition (position) {
            let route = this.$route;
            const scrollPos = position || route.meta?.scrollPos || { x: 0, y: 0 };
            setScrollPosition(scrollPos, route.hash, this.$root);
        },
        checkPermissionPanel: function(panel, key) {
            if(panel){
                return !!(panel ? panel.active && (!panel.acl || panel.acl && this.$auth.check(panel.acl)) : false);
            }
            return false;
        },
        handleBack (fallback, force = false) {
            if (!this.fromRoute || !this.fromRoute.name || force) {
                if(fallback && this.$route?.name != fallback){
                    this.$router.push({ name: fallback});
                }
            } else {
                this.$router.back();
                // this.$router.go(-1)
            }
        },
        fnHasErrors() {
            return !!this.errors.any();
        },
        fnHasError: function(item, scope="form") {
            const fields = scope ? this.fields['$'+scope] : this.fields;
            const name = scope ? (scope+'.'+item) : item;
            return (fields &&
                    fields[item] &&
                    fields[item].dirty &&
                    fields[item].invalid) || this.errors.has(name);
        },
        fnFirstError: function(item, scope="form") {
            const name = scope ? (scope+'.'+item) : item;
            return this.errors.has(name) ? this.errors.first(name) : null;
        },
        fnIsFieldChanged(name, scope="form") {
            const fields = scope ? this.fields['$'+scope] : this.fields;
            return fields && fields[name] ? fields[name].changed : false;
        },
        fnIsFormDirty(scope="form") {
            const fields = scope ? this.fields['$'+scope] : this.fields;
            if (!fields) {
                return false;
            }
            return Object.keys(fields).some(key => fields[key].dirty);
        },
        setFieldDirty(name, scope="form") {
            const matchOptions = {
                name: name,
                scope: scope
            };
            const field = this.$validator.fields.find(matchOptions);
            if(field){
                field.setFlags({ dirty: true });
            }
        },
        async resetFieldValidator(name, scope="form") {
             return new Promise((resolve, reject) => {
                // Disables validation.
                this.$validator.pause();
                this.$nextTick(() => {
                    const matchOptions = {
                      // id: any, // if you have the id, otherwise its optional
                      name: name, // optional
                      scope: scope
                    };
                    const field = this.$validator.fields.find(matchOptions);
                    if(field){
                        field.reset();
                        this.$validator.errors.remove(field.name, field.scope);
                        this.$validator.reset(field);
                    }
                    this.$validator.resume();
                    resolve(true);
                });
            });
        },
        async resetValidator() {
            // Disables validation.
            // this.$validator.pause();
            // return await this.$nextTick(() => {
            //     this.$validator.errors.clear()
            //     this.$validator.fields.items.forEach(field => field.reset())
            //     this.$validator.fields.items.forEach(field => this.errors.remove(field))
            //     // Resets field flags for all scoped fields. Resets all fields if no scope is provided.
            //     this.$validator.reset();
            //     // Enables validation.
            //     return this.$validator.resume();
            //     return true;
            // })

            return new Promise((resolve, reject) => {
                // Disables validation.
                this.$validator.pause();
                this.$nextTick(() => {
                    this.$validator.errors.clear()
                    this.$validator.fields.items.forEach(field => field.reset())
                    this.$validator.fields.items.forEach(field => this.errors.remove(field))
                    // Resets field flags for all scoped fields. Resets all fields if no scope is provided.
                    this.$validator.reset().then(res => {
                        // Enables validation.
                        this.$validator.resume();
                        resolve(true);
                    });
                });
            });
        },
        async validateAll(scope='form') {
            return await this.$validator.validateAll(scope)
            .then(result => {
                if(!result){
                    this.showError('Por favor corrija os erros no formulário');
                    return false;
                }
                return true;
            })
            .catch(error => {
                return false;
            });
        },
        async validateField(name, scope="form") {
            return await this.$validator.validate(`${scope}.${name}`);
        },
        clearMessages: function() {
            this.$root.$helper.messages.removeToast();
        },
        showHttpError: function(error) {
            this.$root.$helper.error.httpError(error);
            if(this.$root.$env.DEBUG){
                console.error(error);
            }
        },
        showWarning: function(message, title=this.pageTitle, callbackClose = ()=>{}, timeout = 3000) {
            this.showMessage(message, title, 'warning', callbackClose, timeout);
        },
        showError: function(message, title=this.pageTitle, callbackClose = ()=>{}, timeout = 3000) {
            this.showMessage(message, title, 'error', callbackClose, timeout);
        },
        showMessage: function(message, title=this.pageTitle, type = 'success', callbackClose = ()=>{}, timeout = 3000) {
            this.$root.$helper.messages.showToast(this.$t(message), this.$t(title), type, callbackClose, timeout);
        },
        activeTooltip(boundary='window') {
            this.$nextTick(function () {
                this.$root.$helper.global.hideTooltip();
                this.$root.$helper.global.activeTooltip(boundary);
            })
        },
        hideTooltip() {
            this.$nextTick(function () {
                this.$root.$helper.global.hideTooltip();
            })
        },
        getFormatUrlAPI(path) {
            return this.$root.$helper.global.formatUrlAPI(path);
        },
        resetUrlAPI(url) {
            return this.$root.$helper.global.resetUrlAPI(url);
        },
        verifyMaxUploadSize(size){
            return size && size/1024/1024 > this.maxUploadSize;
        },
        getMinPasswordLength() {
            return this.$root.$helper.global.getMinPasswordLength();
        },
        assetsPathTheme: function(target) {
            return this.$root.$helper.theme.assetsPathTheme(target);
        },
        assetsPathGlobal: function(target) {
            return this.$root.$helper.theme.assetsPathGlobal(target);
        },
        assetsPathModule: function(target) {
            return this.$root.$helper.theme.assetsPathModule(this.moduleCode || this.moduleInternalCode, target);
        },
        assetsPathGlobalPlatform: function(target) {
            return this.$root.$helper.platform.assetsPathGlobalPlatform(target);
        },
        assetsPathModulePlatform: function(target) {
            return this.$root.$helper.platform.assetsPathModulePlatform(this.moduleCode || this.moduleInternalCode, target);
        },
        resolvePath(obj, path) {
            return resolvePath(obj, path);
        },
        formatString(string, values) {
            return formatString(string, values);
        },
        formatUrl(url, values) {
            return formatUrl(url, values);
        },
        columnValue(obj, column, field=undefined, onlyVal=false) {
            let val = this.resolvePath(obj, field ? field : (column.field_label || column.field));
            val = isFunction(column.func) ? column.func(val) : val;
            if(!onlyVal && column.tooltip) {
                let tooltip = this.resolvePath(obj, column.tooltip);
                if(tooltip){
                    return `<span data-toggle="tooltip-city" data-placement="top" title="${tooltip}">${val}</span>`;
                }
            }
            return val;
        },
        columnStatus(obj, column, status=['fas fa-check', 'fas fa-ban'], css=['text-success', 'text-warning']) {
            let val = this.columnValue(obj, column);
            let icon = (!!val ? `${status[0]} ${css[0]}` : `${status[1]} ${css[1]}`)
            return `<i class="${icon}"></i>`;
        },
        columnOnOff(obj, column, labels=['global.true', 'global.false']) {
            let val = this.columnValue(obj, column);
            return this.$t(!!val ? `${labels[0]}` : `${labels[1]}`);
        },
        convertHex: function(color) {
            return this.$root.$helper.color.convertHex(color);
        },
        getRouterLinkFromPage: function(item, params = {}, urlProperty = 'url') {
            let routeName = 'portal.pages';
            let url = item && urlProperty in item ? item[urlProperty] : null;
            if(url) {
                let router = this.$router;
                url = url.toLocaleLowerCase();
                if(isRelativeURL(url)) {
                    const {route} = router.resolve({path: url});
                    if(route) {
                        routeName = route.name;
                    }
                }else{
                    const resolve = router.resolve({path: '/'});
                    const basePath = new URL(resolve.href, window.location.origin).href.toLocaleLowerCase();
                    if(url.startsWith(basePath)) {
                        const path = url.replace(basePath.replace(/\/$/, ''), '');
                        const {route} = router.resolve({path});
                        if(route) {
                            routeName = route.name;
                        }
                    }
                }
            }

            return {
                name: routeName,
                params
            };
        }
    }
};
